"use client";

import type { ReactNode } from "react";
import type { Testimonial } from "./shallow-types";

import {
  Carousel,
  CarouselContent,
  CarouselItem,
} from "@homeinstead/ui/components/Carousel";
import React from "react";
import { useMediaQuery } from "usehooks-ts";
import QuoteIcon from "~care/components/ui/Icons/ui/quote.svg";

const TestimonialCardTitle = ({ children }: { children: ReactNode }) => (
  <h3 className="font-bold text-lg">{children}</h3>
);
const TestimonialCardContent = ({ children }: { children: ReactNode }) => (
  <p className="text-base leading-relaxed">{children}</p>
);

const TestimonialCard = ({
  children,
}: {
  key: string;
  children: ReactNode;
}) => {
  return (
    <div className="relative h-[364px] max-w-xs select-none rounded-3xl bg-[#e6f3ff] p-6 md:max-w-sm">
      {/* Large quotation mark */}
      <div className="absolute -top-4 font-serif text-8xl text-new-beginnings-base leading-none">
        <QuoteIcon />
      </div>

      {/* Content with proper spacing to account for the quotation mark */}
      <div className="mt-10 space-y-4 text-new-beginnings-base">{children}</div>
    </div>
  );
};

const TestimonialCarousel = ({
  carouselTitle = "Hear from our customers",
  testimonials,
  keyPrefix,
}: {
  carouselTitle?: string;
  keyPrefix: string;
  testimonials: Testimonial[];
}) => {
  const isViewportXL = useMediaQuery("(min-width: 1280px)");

  return (
    <>
      <h2 className="px-4 pt-20 pb-8 font-editorial-new font-light text-1xl text-new-beginnings-base sm:px-10 xl:px-[152px]">
        {carouselTitle}
      </h2>
      <Carousel canDrag={!isViewportXL}>
        <CarouselContent className="ml-4 cursor-pointer xl:cursor-auto xl:justify-center">
          {testimonials.map((testimonial, index) => (
            <CarouselItem className="max-w-fit pt-8 pr-4" key={index}>
              <TestimonialCard key={keyPrefix + "-" + index}>
                <TestimonialCardTitle>{testimonial.name}</TestimonialCardTitle>
                <TestimonialCardContent>
                  {testimonial.text}
                </TestimonialCardContent>
              </TestimonialCard>
            </CarouselItem>
          ))}
        </CarouselContent>
      </Carousel>
    </>
  );
};

export default TestimonialCarousel;
